import { defaultTheme } from '../../theming/data/defaultTheme'
import border from '../../tokens/border'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import layout from '../../tokens/layout'
import styled from 'styled-components'
import typography from '../../tokens/typography'
import { composeTheme } from '../../utils/compose-theme'

export const Wrapper = styled.div`
  font-family: ${fonts.inter};
  font-size: ${typography.fontSize.fontSizeXxs};
  line-height: ${typography.fontHeight.lineHeightMd};
  font-weight: ${typography.fontWeight.fontWeightRegular};
  display: flex;
  color: ${colors.neutralColorLowPure};
  align-items: center;

  &.is-disabled {
    color: ${colors.neutralColorLowMedium};
  }
`

export const Box = styled.div.attrs((props) => composeTheme(props))`
  display: flex;
  width: ${(props) => props.theme.radioButton.size};
  height: ${(props) => props.theme.radioButton.size};
  cursor: pointer;
  position: relative;
  margin-right: ${(props) => props.theme.radioButton.marginRight};
  border-radius: ${border.radius.radiusCircular};
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  border: ${(props) => props.theme.radioButton.borderWidth} solid
    ${(props) => props.theme.radioButton.borderColor};

  &.unselected {
    border-color: ${(props) => props.theme.radioButton.borderColor};
    background-color: ${(props) => props.theme.radioButton.background};
  }

  &.negative {
    border-color: ${colors.feedbackColorNegativePure};
  }

  &.selected {
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
    border-color: ${(props) => props.theme.brandColors.primaryPure};
    background-color: ${(props) => props.theme.radioButton.selectedBackground};

    .MuiSvgIcon-root {
      width: 2.5rem;
      color: ${colors.neutralColorHighPure};
    }
  }

  &.is-disabled {
    cursor: not-allowed;
    pointer-events: none;
    background-color: ${colors.neutralColorHighPure} !important;
    border-color: ${colors.neutralColorLowLight} !important;
  }
`

Box.defaultProps = defaultTheme

export const RadioButtonIcon = styled.div.attrs((props) => composeTheme(props))`
  width: ${(props) => props.theme.radioButton.radioIconSize};
  height: ${(props) => props.theme.radioButton.radioIconSize};
  cursor: pointer;
  position: relative;
  border-radius: ${border.radius.radiusCircular};

  &.negative {
    background-color: ${colors.feedbackColorNegativePure};
  }

  &.selected {
    background-color: ${(props) => props.theme.brandColors.primaryPure};

    &.is-disabled {
      background-color: ${colors.neutralColorLowLight} !important;
    }
  }
`

RadioButtonIcon.defaultProps = defaultTheme

export const RadioButtonGrid = styled.div`
  .div1 {
    margin-bottom: ${layout.margin.spacingXxxs};
  }
`
